export const MENU_TYPE_MEGA_MENU = 'mega-menu';
export const MENU_TYPE_DEFAULT = 'default';
export const MENU_TYPE_MOBILE = 'mobile';
export const DEFAULT_TIMEOUT = 1000;
export const NONPROD_TIMEOUT = 3000;
